const FROM_EMAIL = process.env.FROM_EMAIL

if (!FROM_EMAIL) throw new Error('Please provide FROM_EMAIL environment variable')

export const EMAIL_OPTIONS = { FROM_EMAIL }
export const SEND_EMAIL_IN_LOCAL = Boolean(process.env.SEND_EMAIL_IN_LOCAL)
